<template>
    <v-container>
        <v-data-table :headers="headers" :items="items" :search="search" class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Investicie</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                Nova investicia
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model="editedItem.contract_number"
                                                label="Contract Number"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model="editedItem.user" label="Pouzivatel"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model.number="editedItem.investment_amount"
                                                label="Suma investicie" type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model.number="editedItem.coefficient" label="Koeficient"
                                                type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model.number="editedItem.payout_claim" label="Narok"
                                                type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-checkbox v-model="editedItem.status" label="Aktivne"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Zrusit</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Ulozit</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
            <template v-slot:item.status="{ item }">
                <v-chip :color="item.status ? 'green' : 'red'" dark>{{ item.status ? 'Active' : 'Inactive' }}</v-chip>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { APIService } from "@/http/APIService.js";
const apiService = new APIService();

export default {
    data: () => ({
        dialog: false,
        search: '',
        headers: [
            { text: 'ID', value: 'id' },
            { text: 'Cislo zmluvy', value: 'contract_number' },
            { text: 'Pouzivatel', value: 'user' },
            { text: 'Suma investicie', value: 'investment_amount' },
            { text: 'Koeficient', value: 'coefficient' },
            { text: 'Narok', value: 'payout_claim' },
            { text: 'Status', value: 'status' },
            { text: 'Vytvorene', value: 'created_at' },
            { text: 'Akcie', value: 'actions', sortable: false },
        ],
        items: [],
        editedIndex: -1,
        editedItem: {
            contract_number: '',
            user: null,
            investment_amount: 0,
            coefficient: 0,
            payout_claim: 0,
            status: false,
        },
        defaultItem: {
            contract_number: '',
            user: null,
            investment_amount: 0,
            coefficient: 0,
            payout_claim: 0,
            status: false,
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'New Investment' : 'Edit Investment';
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            apiService.getAdminInvestments('', '', 100, 0).then(response => {
                this.items = response.results;
            });
        },

        editItem(item) {
            this.editedIndex = this.items.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        deleteItem(item) {
            if (confirm('Naozaj chcete zmazat?')) {
                apiService.deleteAdminInvestment(item).then(() => {
                    this.initialize();
                });
            }
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        save() {
            if (this.editedIndex > -1) {
                apiService.updateAdminInvestment(this.editedItem).then(() => {
                    this.initialize();
                });
            } else {
                apiService.createAdminInvestment(this.editedItem).then(() => {
                    this.initialize();
                });
            }
            this.close();
        },
    },
};
</script>